import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';

import { getWorkloadsQueryKey } from 'hooks/queries/workload-optimization/useWorkloadsQuery';

export const useCreateCustomMetricsDataSourceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: apiClient.workloadOptimization.createCustomMetricsDataSource,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getWorkloadsQueryKey(),
      });
    },
  });
};
